/* eslint-disable max-len */
import { contactTypes } from '../types/contact.types';

const initialState = {
  collection: [],
  count: 0,
  limit: 10,
  contact: null,
  passGenerated: {
    password: '',
    loading: false
  },
  passError: '',
  cargando: false,
  loadingContact: false,
  loading: false,
  update: false,
  contracts: [],
  contactData: {
    loading: false,
    entry: null,
    message: ''
  },
  updatedContactData: {
    loading: false,
    message: ''
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case contactTypes.GET_CONTACTS:
      return { ...state, cargando: true };
    case contactTypes.GET_CONTACTS_SUCCESS:
      return {
        ...state,
        cargando: false,
        collection: action.payload.contacts,
        count: action.payload.count,
        limit: action.payload.limit,
      };
    case contactTypes.GET_CONTACTS_FAILED:
      return { ...state, cargando: false, error: action.payload.error };
    case contactTypes.GET_CONTACT_DATA:
      return { ...state, contactData: { ...state.contactData, loading: true } };
    case contactTypes.GET_CONTACT_DATA_SUCCESS:
      return { ...state, contactData: { ...state.contactData, loading: false, entry: action.payload.body } };
    case contactTypes.GET_CONTACT_DATA_FAILED:
      return { ...state, contactData: { ...state.contactData, loading: false, error: action.payload.error } };
    case contactTypes.GET_CONTACT_RUT:
      return { ...state, loadingContact: true, update: false };
    case contactTypes.GET_CONTACT_RUT_SUCCESS:
      return {
        ...state,
        loadingContact: false,
        update: true,
        contact: action.payload.contact,
      };
    case contactTypes.GET_CONTACT_RUT_FAILED:
      return {
        ...state,
        loadingContact: false,
        error: action.payload.error,
        update: true,
      };
    case contactTypes.GET_CONTRACT_BY_RUT:
      return { ...state, cargandoContract: true, update: false };
    case contactTypes.GET_CONTRACT_BY_RUT_SUCCESS:
      return {
        ...state,
        cargandoContract: false,
        update: true,
        contracts: action.payload.contracts,
      };
    case contactTypes.GET_CONTRACT_BY_RUT_FAILED:
      return {
        ...state,
        cargandoContract: false,
        error: action.payload.error,
        update: false,
      };
    case contactTypes.CREATE_CONTACTS:
      return { ...state, creatting: true };
    case contactTypes.CREATE_CONTACTS_SUCCESS:
      return { ...state, contact: action.payload.contact, creatting: false };
    case contactTypes.CREATE_CONTACTS_FAILED:
      return { ...state, error: action.error, creatting: false };
    case contactTypes.GENERATE_PASS:
      return { ...state, loading: true };
    case contactTypes.GENERATE_PASS_SUCCESS:
      return { ...state, passGenerated: { ...state.passGenerated, loading: false, password: action.payload }, loading: false };
    case contactTypes.GENERATE_PASS_FAILED:
      return { ...state, passGenerated: { ...state.passGenerated, loading: false, error: action.error }, loading: false };
    case contactTypes.UPDATE_CONTACT:
      return { ...state, cargando: true };
    case contactTypes.UPDATE_CONTACT_SUCCESS:
      return { ...state, cargando: false };
    case contactTypes.UPDATE_CONTACT_FAILED:
      return { ...state, cargando: false, error: action.payload.error };
    case contactTypes.UPDATE_CONTACT_DATA:
      return { ...state, updatedContactData: { ...state.updatedContactData, loading: true } };
    case contactTypes.UPDATE_CONTACT_DATA_SUCCESS:
      return { ...state, updatedContactData: { ...state.updatedContactData, loading: false } };
    case contactTypes.UPDATE_CONTACT_DATA_FAILED:
      return { ...state, updatedContactData: { ...state.updatedContactData, loading: false, error: action.payload.error } };
    case contactTypes.DELETE_CONTACTS:
      return { ...state };
    case contactTypes.DELETE_CONTACTS_SUCCESS:
      return { ...state };
    case contactTypes.DELETE_CONTACTS_FAILED:
      return { ...state };
    case contactTypes.RESET_CONTACT_STATE:
      return initialState;
    case contactTypes.RESET_CONTACT_DATA:
      return { ...state, contactData: initialState.contactData };
    case contactTypes.RESET_CONTACT:
      return { ...state, contact: null, cargando: false };
    default:
      return state;
  }
};
